import { useEffect, useState, useCallback } from 'react';
import { ErrorState } from 'types/Payable';
import {
  Deposit,
  Condition,
  DayType,
  DepositPayable,
  FormCondition,
  SpecialConditionData,
} from '@urbanx/agx.campaigns.client';
import { AgxOnOrDaysFrom, ContractDateType } from '@urbanx/agx.ui-components2';
import { isEqual } from 'lodash-es';

interface BuildingAndPestPayableProps {
  id: string;
  onValueChanged: (change: { id: string; value: Deposit }) => void;
  defaultValue: Deposit;
  validate?: boolean;
  required?: boolean;
  error?: ErrorState;
  specialConditions: SpecialConditionData[];
  campaignId: string;
}

const conditionsToInclude = [Condition.OnSpecificDate];

const BuildingAndPestPayable = ({
  id,
  defaultValue,
  onValueChanged,
  validate = false,
  specialConditions,
  campaignId,
}: BuildingAndPestPayableProps) => {
  const [buildingAndPestConditionDetails, setBuildingAndPestConditionDetails] =
    useState<Deposit>({
      ...defaultValue,
      dayType: defaultValue?.dayType ?? DayType.Days,
      depositPayable: defaultValue?.depositPayable ?? DepositPayable.NDaysFrom,
    });

  useEffect(() => {
    if (!buildingAndPestConditionDetails) return;

    if (isEqual(buildingAndPestConditionDetails, defaultValue)) return;

    onValueChanged({
      id,
      value: buildingAndPestConditionDetails,
    });
  }, [buildingAndPestConditionDetails]);

  const onConditionChange = useCallback((value: FormCondition) => {
    setBuildingAndPestConditionDetails(prev => ({
      ...prev,
      condition: (value.condition as unknown as Condition) ?? Condition.OnDate,
      daysFromDate: value.daysFromDate,
      depositPayable: value.depositPayable,
      dayType: value.dayType as unknown as DayType,
      specialConditionId: value.specialConditionId,
      referenceDate: value.referenceDate,
      other: value.other,
    }));
  }, []);

  return (
    <AgxOnOrDaysFrom
      id={id}
      condition={buildingAndPestConditionDetails as FormCondition}
      conditionsToIncludeInDaysFrom={conditionsToInclude}
      conditionsToIncludeInOn={conditionsToInclude}
      specialConditions={specialConditions}
      campaignId={campaignId}
      validate={validate}
      defaultCondition={Condition.OnDate}
      contractDateType={ContractDateType.ContractDate}
      onChange={onConditionChange}
      onIsValidChange={() => {}}
    />
  );
};

export default BuildingAndPestPayable;
